import React from "react";
//import bear from "../../../static/vi-bear.svg";
import { UncontrolledDropdown } from "../Dropdown/Dropdown";
import { DropdownToggle } from "../DropdownToggle/DropdownToggle";
import { DropdownMenu } from "../DropdownMenu/DropdownMenu";
/**
 * This Component provides an avatar and a dropdown menu for account specific actions (login, logout)
 * TODO fix bear
 */

export interface WAProfileProps {
  imgProps?: React.ImgHTMLAttributes<HTMLImageElement>;
}

export const WAProfile: React.FC<WAProfileProps> = props => {
  return (
    <UncontrolledDropdown>
      <DropdownToggle className="avatar-toggle dropdown-toggle" tag="button">
        <img alt="profile" height="100%" {...props.imgProps}></img>
      </DropdownToggle>
      <DropdownMenu>{props.children}</DropdownMenu>
    </UncontrolledDropdown>
  );
};
